var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLineArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3166 21.5165C11.0287 21.8261 10.6386 22 10.2318 22C9.82507 22 9.43493 21.8261 9.14712 21.5165L0.448909 12.1487C0.161458 11.8388 -4.62528e-07 11.4186 -4.81677e-07 10.9805C-5.00826e-07 10.5424 0.161458 10.1223 0.448909 9.81229L9.14712 0.444488C9.43804 0.152119 9.82301 -0.00715631 10.2209 0.000245373C10.6187 0.00764705 10.9983 0.181147 11.2797 0.484163C11.5611 0.787194 11.7222 1.19605 11.729 1.62453C11.7359 2.053 11.588 2.46761 11.3166 2.78093L5.23804 9.32737L20.465 9.32737C20.8721 9.32737 21.2626 9.50154 21.5504 9.81156C21.8383 10.1216 22 10.5421 22 10.9805C22 11.4189 21.8383 11.8394 21.5504 12.1495C21.2626 12.4595 20.8721 12.6337 20.465 12.6337L5.23804 12.6337L11.3166 19.1801C11.604 19.4901 11.7655 19.9102 11.7655 20.3483C11.7655 20.7864 11.604 21.2066 11.3166 21.5165Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineArrowLeft);
export default __webpack_public_path__ + "static/media/icon-line-arrow-left.26c8f45f2d21bd0dde444fa9c9d7bf78.svg";
export { ForwardRef as ReactComponent };